<template>
  <table class="skuGrid sprocket__table sprocket__table--bordered sprocket__table--striped-body-even">
    <thead class="skuGrid__head">
      <tr class="skuGrid__head__row">
        <th class="skuGrid__hitem w-3 text-center" data-type="input-checkbox" scope="col">
          <label class="skuGrid__data-input--checkbox">
            <input class="skuGrid__data-input" type="checkbox" value="chekbox-value" />
            <i class="skuGrid__data-input-icon is-indeterminate"></i>
          </label>
        </th>
        <th class="skuGrid__hitem w-5" data-type="string" scope="col">SKU</th>
        <th class="skuGrid__hitem w-20" data-type="string" scope="col">Item</th>
        <th class="skuGrid__hitem w-5" data-type="string" scope="col">UPC/EAN</th>
        <th class="skuGrid__hitem w-5" data-type="string" scope="col">Date Added</th>
        <th
          v-for="warehouse in data.bikes[0].entries[0].warehouses"
          :key="warehouse.id"
          class="skuGrid__hitem w-5"
          data-type="warehouse"
          scope="col"
        >
          {{ warehouse.id }}
        </th>
        <th class="skuGrid__hitem w-10" data-type="stock-watch" scope="col">Stock Watch</th>
        <th class="skuGrid__hitem w-10" data-type="price" scope="col">Unit Price</th>
        <th class="skuGrid__hitem w-5 text-right" data-type="input-number" scope="col">Qty</th>
      </tr>
    </thead>
    <tbody class="skuGrid__body">
      <tr v-for="(item, index) in data.bikes[0].entries" :key="index" class="skuGrid__data__row">
        <td class="skuGrid__item text-center" data-header-label="" data-type="input-checkbox">
          <label class="skuGrid__data-input--checkbox">
            <input class="skuGrid__data-input" type="checkbox" checked="" value="chekbox-value" />
            <i class="skuGrid__data-input-icon"></i>
          </label>
        </td>
        <td class="skuGrid__item" data-header-label="SKU" data-type="string">{{ item.sku }}</td>
        <td class="skuGrid__item" data-header-label="Item" data-type="string">{{ item.itemName }}</td>
        <td class="skuGrid__item" data-header-label="UPC/EAN" data-type="string">{{ item.upc }}</td>
        <td class="skuGrid__item" data-header-label="Date Added" data-type="string">{{ item.dateAdded }}</td>

        <td
          v-for="warehouse in item.warehouses"
          :key="warehouse.id"
          class="skuGrid__item"
          data-header-label="WDC"
          data-type="warehouse"
        >
          <div class="warehouse__wrapper">
            <span class="value" data-level="zero">{{ warehouse.stockLevel }}</span>
            <span class="value-label">No ETA</span>
          </div>
        </td>
        <td class="skuGrid__item" data-header-label="Stock Watch" data-type="stock-watch">
          <div class="skuGrid__stockwatch__wrapper">
            <button type="button" class="skuGrid__stockwatch__item-btn is-disabled">
              <i class="skuGrid__stockwatch__item-icon material-icons">visibility_off</i>
              <span class="skuGrid__stockwatch__item-label">WDC</span>
            </button>
            <button type="button" class="skuGrid__stockwatch__item-btn is-disabled">
              <i class="skuGrid__stockwatch__item-icon material-icons">visibility_off</i>
              <span class="skuGrid__stockwatch__item-label">Any</span>
            </button>
          </div>
        </td>
        <td class="skuGrid__item" data-header-label="Unit Price" data-type="price">
          <div class="skuGrid__price__wrapper">
            <span class="value">{{ item.price[0].sale }}</span>
          </div>
        </td>
        <td class="skuGrid__item text-right" data-header-label="Qty" data-type="input-number">
          <div class="input-group align-right">
            <input class="skuGrid__data-input w-auto" type="text" placeholder="15" size="2" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data() {
    return {
      data: null,
    };
  },
  created() {
    fetch(ACC.config.encodedContextPath + '/saved-lists/lists')
      .then((req) => req.json())
      .then((data) => fetch(ACC.config.encodedContextPath + '/saved-lists/' + data.user[0].id))
      .then((req) => req.json())
      .then((data) => {
        this.data = data;
      });
  },
};
</script>
